import React, { useEffect, useState } from 'react';
import { IconClose, Modal } from 'takeat-design-system-ui-kit';
import api from '~/services/api';
import { useAuth } from '~/context/AuthContext';
import toast from 'react-hot-toast';
import {
  ClosingCashierTableColumn,
  ClosingCashierTableContainer,
  ClosingCashierTableHeader,
} from '../PinpadTotemModal/styles';
import PinpadTotemModalRow from '../PinpadTotemModal/PinpadTotemModalRow';

const PosWaitingPaymentModal = (props) => {
  const { posModal, setPosModal } = props;
  const { paymentMethodsState } = useAuth();
  const [transactions, setTransactions] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);

  useEffect(() => {
    if (!posModal) return;
    const getTransactions = async () => {
      try {
        const response = await api.get(
          '/restaurants/orders/pos/waiting-payment'
        );
        setTransactions(response.data);
      } catch (e) {
        toast.error(
          'Erro ao buscar transações do POS. Tente novamente mais tarde.'
        );
        console.log('pos orders error', e);
      }
    };
    getTransactions();
  }, [posModal]);

  const confirmPosPayment = async (
    paymentMethodId,
    sessionId,
    amount,
    setLoading
  ) => {
    setLoading(true);
    await api
      .post('/restaurants/orders/pos/confirm-payment', {
        session_id: sessionId,
        amount,
        payment_method_id: paymentMethodId,
      })
      .then((response) => {
        setPosModal(false);
        toast.success('Pagamento confirmado com sucesso!');
      })
      .catch((error) => {
        if (error?.response?.data?.message) {
          toast.error(error.response.data.message);
        }
        console.log('pos confirm payment error', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    const sortedPaymentMethods = paymentMethodsState
      .filter((method) => method.available)
      .sort((a, b) => b.name.localeCompare(a.name))
      .sort((a, b) => (b.is_favorite === true ? 1 : -1));

    const sortedPaymentMethodsFormatted = sortedPaymentMethods.map((method) => {
      return {
        value: method.id,
        label: method.name,
      };
    });
    setPaymentMethods(sortedPaymentMethodsFormatted);
  }, [paymentMethodsState]);

  const getStatusTransaction = (status) => {
    switch (status) {
      case 'paid':
        return 'Pago';
      case 'pending':
        return 'Pendente';
      case 'canceled':
        return 'Cancelado';
      case 'closed':
        return 'Finalizado';
      case 'waiting_payment':
        return 'Aguardando pagamento';
      case 'finished':
        return 'Finalizado';
      default:
        return status;
    }
  };
  return (
    <Modal
      style={{
        maxWidth: 800,
        maxHeight: 764,
        padding: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        position: 'relative',
      }}
      open={posModal}
      toggle={() => setPosModal(false)}
    >
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <h2
            style={{
              margin: 0,
              fontWeight: 600,
              fontSize: 18,
              lineHeight: '24px',
              color: '#222',
            }}
          >
            Pagamentos via POS
          </h2>
          <IconClose
            fontSize={24}
            style={{ cursor: 'pointer' }}
            onClick={() => setPosModal(false)}
          />
        </div>
        <p
          style={{
            margin: 0,
            fontWeight: 500,
            fontSize: 14,
            lineHeight: '20px',
            letterSpacing: 0.1,
            color: '#545454',
          }}
        >
          Para pedidos pendentes de pagamento, selecione o método de pagamento e
          clique em &ldquo;Pagar&rdquo;.
        </p>
      </div>
      <ClosingCashierTableContainer
        style={{
          borderRadius: 8,
          minHeight: 496,
          overflow: 'auto',
          border: '1px solid #f6f6f6',
        }}
      >
        <ClosingCashierTableHeader>
          <ClosingCashierTableColumn>Data e hora</ClosingCashierTableColumn>
          <ClosingCashierTableColumn>Valor</ClosingCashierTableColumn>
          <ClosingCashierTableColumn>Status</ClosingCashierTableColumn>
          <ClosingCashierTableColumn>
            Método de pagamento
          </ClosingCashierTableColumn>
          <ClosingCashierTableColumn
            style={{
              width: 88,
            }}
          />
        </ClosingCashierTableHeader>
        {transactions &&
          transactions.length > 0 &&
          transactions.map((transaction) => (
            <PinpadTotemModalRow
              transaction={transaction}
              confirmPinpadTotemTransaction={(
                paymentMethodId,
                sessionId,
                setLoading
              ) =>
                confirmPosPayment(
                  paymentMethodId,
                  sessionId,
                  parseFloat(transaction.total_price),
                  setLoading
                )
              }
              paymentMethods={paymentMethods}
              getStatusTransaction={getStatusTransaction}
              key={transaction.id}
            />
          ))}
      </ClosingCashierTableContainer>
      <div />
    </Modal>
  );
};

export default PosWaitingPaymentModal;
